import React from 'react'
import { ErrorModal } from '../../../components/ErrorModal'

const message = 'We are matching the best candidates for you. Please check back later.'

export const NoCandidates = () => <ErrorModal message={message} />
